// API ENDPOINTS
export const BASE_URL =
  process.env.NODE_ENV === 'production' ? '#{ExperienceApiBaseUrl}' : 'https://priority-servicesdev.yorkswater.com/api';

// Endpoints
export const API_BASE_URL = `${BASE_URL}/api`;

export const API_ENDPOINTS = {
  CUSTOMERS: `${API_BASE_URL}/customers`,
  SUBMIT_FORM: BASE_URL,
  SERVICES: `${BASE_URL}/services`,
  CATEGORIES: `${BASE_URL}/categories`,
  VALIDATE_CRN_AND_POSTCODE: `${BASE_URL}/accounts/check`,
  POSTCODE_LOOKUP: `${BASE_URL}/property`,
  POSTCODE_ANYWHERE_LOOKUP: `${BASE_URL}/address`,
  LANGUAGES: `${BASE_URL}/languages`,
  AUTO_ENROL: `${BASE_URL}/precheck`,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { API_BASE_URL, API_ENDPOINTS, BASE_URL };
